// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
export var DependencyTypes = (/*@__PURE__*/createEnumStyle({
    /**
     * InProc
     */
    InProc: "InProc" /* eDependencyTypes.InProc */,
    /**
     * Quene Message
     */
    QueueMessage: "Queue Message" /* eDependencyTypes.QueueMessage */,
    /**
     * Sql
     */
    Sql: "SQL" /* eDependencyTypes.Sql */,
    /**
     * Http
     */
    Http: "Http" /* eDependencyTypes.Http */,
    /**
     * Grpc
     */
    Grpc: "GRPC" /* eDependencyTypes.Grpc */,
    /**
     * Wcf
     */
    Wcf: "WCF Service" /* eDependencyTypes.Wcf */
}));
//# sourceMappingURL=DependencyTypes.js.map